import { InvoiceStatus } from '../Types/Invoices.types';

export const StatusTypes: InvoiceStatus[] = [
	'expired',
	'failed',
	'new',
	'paid',
	'pending',
];
